export default __webpack_public_path__ + "static/media/Gradient 2.178d79ce.png";